<template>
  <div>
      <router-view />
  </div>
</template>

<style lang="scss">
  .md-primary {
      background-color: #93DBFA !important;
  }

  .container {
    max-width: 540px;
    margin: 0 auto;
  }
</style>


<script>
export default {
  name: "App",
};
</script>
